// extracted by mini-css-extract-plugin
module.exports = {"Description":"Description_Description__89AOm"};